import axios from "axios";
import config from "../config";

  const apiClient = axios.create({
    baseURL: config.apiHost,
    timeout: config.timeout,
  });

  // Attach JWT token to every request
  apiClient.interceptors.request.use(
    (config) => {
      const token = sessionStorage.getItem("jwt");
      if (token) config.headers.Authorization = `Bearer ${token}`;
      return config;
    },
    (error) => Promise.reject(error)
  );

  // Handle 401 globally and sanitize 5xx errors
  apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        sessionStorage.removeItem("jwt");
        window.location.href = "/login";
      }
      if (error.response?.status >= 500) {
        error.response.data = {
          status: "error",
          message: "A network error occurred. Please try again later.",
        };
      }
      return Promise.reject(error);
    }
  );

  export default apiClient;